module.exports = __webpack_public_path__ + "static/media/Copy_of_IMG_1305.b8ab8a92.jpg";